<template>
	<el-container>
		<el-header>
			<el-row type="flex" justify="space-between">
				<el-col :span="6">
					<div class="jzq-logo">
						<img src="/images/ptlogo.png"/>
					</div>
				</el-col>
				<el-col :span="4" style="min-width: 300px;background: #464c5b;">
					<div class="jzq-return">
						<ul>
							<li><a :href="junziqanIndex">进入官网</a></li>
							<!--<li><a href="" @click="goto(2)">快速登陆</a></li>-->
						</ul>
					</div>
				</el-col>
			</el-row>
    </el-header>
    <el-main>
      <nuxt/>
    </el-main>
  </el-container>
</template>

<script>
  import GlobalConfig from '@/assets/js/config/global';
	import {ding_erformance} from "./js/entConsoleDate.js"
	export default {
		name: "auth",
    data(){
		  return{
        junziqanIndex:GlobalConfig.domain.junziqanIndex
      }
    },
		methods: {
			goto(type) {
				if (type === 1) {
					this.$router.push('/login')
				} else {
					this.$router.push('/login')
				}
			}
		},
		mounted(){
			ding_erformance()
		}
	}
</script>

<style scoped>
.jzq-logo, .jzq-return {
	height: 60px;
}
.jzq-logo {
	text-align: right;
}
.jzq-logo img {
	margin: 13px;
}
.jzq-return ul {padding: 0; margin: 0;height: 100%;}
.jzq-return ul li {display: inline-block;height: 100%;line-height: 60px;}
.jzq-return ul li a{color: rgb(240, 240, 240);padding: 0 15px;}
/*.jzq-return ul li:first-child a {border-right: 2px solid rgb(233, 233, 233)}*/
.jzq-return ul li a:hover{color: white;}
</style>



// WEBPACK FOOTER //
// layouts/auth.vue